import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { Collapse } from 'reactstrap';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import { ReactComponent as UserIcon } from 'assets/icon-user.svg';
import { ReactComponent as CaretDownIcon } from 'assets/icon-angle-down.svg';
import { ReactComponent as SettingsIcon } from 'assets/icon-settings.svg';
import { ReactComponent as RedesignIcon } from 'assets/icon-redesign.svg';
import { ReactComponent as LogoutIcon } from 'assets/icon-close-session.svg';
import { ReactComponent as LockIcon } from 'assets/icon-lock.svg';

import { colors } from 'shared/defaultTheme';

import { logout } from 'redux/actions/authActions';

import {
  changeDefaultLanguage,
  changeDefaultLanguageCustom,
  changeSearchValue,
} from 'redux/actions/topBarActions';

import TopbarMenuLink from './TopbarMenuLink';
import { UserWrapper } from './styles';

const TopbarProfile = ({ textColor }) => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const { initials, isCustomer, name, i18 } = useSelector((state) => state.auth);
  const { selectedDefaultLanguageCustom } = useSelector((state) => state.topBar);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const handleToggleCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };
  const onLogout = () => {
    dispatch(logout());
    i18n.changeLanguage(isCustomer ? selectedDefaultLanguageCustom : i18);
    dispatch(changeDefaultLanguage(null));
    dispatch(changeDefaultLanguageCustom(null));
    dispatch(changeSearchValue(''));
  };

  return (
    <div className="topbar__profile">
      <button type="button" className="topbar__avatar" onClick={handleToggleCollapse}>
        <div className="topbar__avatar-img d-flex justify-content-center align-items-center">
          <span className="text-capitalize avatar__text">{initials}</span>
        </div>
        <CaretDownIcon
          fill={textColor}
          className={classNames({
            topbar__icon: !isCollapsed,
            'topbar__icon-rotate': isCollapsed,
          })}
        />
      </button>
      {isCollapsed && (
        <button
          type="button"
          aria-label="button collapse"
          className="topbar__back"
          onClick={handleToggleCollapse}
        />
      )}
      <Collapse isOpen={isCollapsed} className="topbar__menu-wrap">
        <div className="topbar__menu">
          <UserWrapper>
            <UserIcon width={20} className="mb-2" fill={colors.suvaGrey} />
            <span className="">{name}</span>
          </UserWrapper>
          {isCustomer && (
            <>
              <TopbarMenuLink
                title={t('general_settings')}
                icon={<SettingsIcon />}
                path="/settings"
              />
              <TopbarMenuLink
                title={t('general_customization')}
                icon={<RedesignIcon />}
                path="/general_customization/edit"
              />
              <TopbarMenuLink
                title={t('general_access_manager')}
                icon={<LockIcon />}
                path="/access_manager"
              />
            </>
          )}
          <TopbarMenuLink
            title={t('general_logout')}
            icon={<LogoutIcon />}
            path="/"
            onClick={onLogout}
          />
        </div>
      </Collapse>
    </div>
  );
};

TopbarProfile.propTypes = {
  textColor: PropTypes.string.isRequired,
};

export default TopbarProfile;
